//#region src/js/youtube-loader.js
var YouTubeLoader = class {
	constructor() {
		this.youtubePlaceholders = document.querySelectorAll("[data-youtube-loader]");
		this.init();
	}
	init() {
		this.youtubePlaceholders.forEach((placeholder) => {
			placeholder.querySelector("[data-youtube-play]").addEventListener("click", () => this.loadVideo(placeholder));
		});
	}
	loadVideo(placeholder) {
		const videoId = placeholder.getAttribute("data-video-id");
		const iframe = document.createElement("iframe");
		iframe.setAttribute("src", `https://www.youtube.com/embed/${videoId}?autoplay=1`);
		iframe.setAttribute("class", "block object-cover w-full h-full youtube");
		iframe.setAttribute("frameborder", "0");
		iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture");
		iframe.setAttribute("allowfullscreen", "");
		placeholder.innerHTML = "";
		placeholder.appendChild(iframe);
	}
};
document.addEventListener("DOMContentLoaded", () => {
	new YouTubeLoader();
});
//#endregion
